module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/v2.1.1-rc.5-84.vue");


//////////////////
// WEBPACK FOOTER
// ./en/changelog/v2.1.1-rc.5.md
// module id = 501
// module chunks = 342